import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="py-20 text-center">
      <p className="text-sm uppercase tracking-widest text-nm-accent">404</p>
      <h1 className="mt-2 text-3xl font-semibold">Page not found</h1>
      <Link
        to="/leads"
        className="mt-6 inline-block rounded-md border border-nm-border px-4 py-2 text-sm text-nm-ink hover:border-nm-accent"
      >
        Back to leads
      </Link>
    </section>
  );
}
